import { useEffect, useState } from 'react';
import { useStatus } from '../../../hooks';
import { WheelsPricingConfig } from '../../../domain/wheels';
import { WheelsService } from '../../../services/wheels';

export const useWheelsPricingConfig = () => {
  const [pricingConfig, setPricingConfig] = useState<WheelsPricingConfig | null>(null);
  const { isDone, isLoading, setStatusLoading, setStatusDone, setStatusError } = useStatus();

  const fetchPricingConfig = async () => {
    setStatusLoading();

    try {
      const service = new WheelsService();
      const config = await service.getPriceConfig();
      
      // Add cbx as a selectable zone
      config.zones.unshift({ name: 'cbx', display: 'Cross Border Xpress' });
      setPricingConfig(config);

      setStatusDone();
    } catch (error) {
      setStatusError();
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPricingConfig();
  }, []);

  return { pricingConfig, isDone, isLoading, fetchShuttleRoutes: fetchPricingConfig };
};
